import { TranslateService } from '@ngx-translate/core';
import { CommentFilterModel } from './../../../../models/Comment.model';
import { SharedService } from './../../../../services/shared/shared.service';
import { CommentService } from '../../../../services/Comment/comment.service';
import { Component, Input } from '@angular/core';
import { AlertController, PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-news-comment-popover',
  templateUrl: './news-comment-popover.component.html',
  styleUrls: ['./news-comment-popover.component.scss'],
  standalone: false,
})
export class NewsCommentPopoverComponent {
  constructor(
    private commentService: CommentService,
    private sharedService: SharedService,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private storage: Storage,
    private popoverCtrl: PopoverController,
  ) {}

  employeeId: string = '';
  @Input() commentId: string = '';
  @Input() comment: any;
  filter: CommentFilterModel = new CommentFilterModel();

  async ionViewWillEnter() {
    this.employeeId = await this.storage.get('employeeId');
  }

  async deleteComment() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('news.comments.label.deleteComment'),
      message: this.translate.instant('news.comments.label.deleteCommentMessage'),
      buttons: [
        {
          text: this.translate.instant('common.cancel'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('common.confirm'),
          role: 'ok',
          handler: async () => {
            this.sharedService.showLoading();

            await lastValueFrom(this.commentService.deleteComment(this.commentId)).then(
              () => {
                this.sharedService.showToast(this.translate.instant('news.comments.success.delete'));
                this.sharedService.dismissLoading();
                this.popoverCtrl.dismiss({ refresh: true, comment: null });
              },
              () => {
                this.sharedService.dismissLoading();
              },
            );
          },
        },
      ],
    });
    await alert.present();
  }

  async reportComment() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('news.comments.label.reportComment'),
      message: this.translate.instant('news.comments.label.reportCommentMessage'),
      buttons: [
        {
          text: this.translate.instant('common.cancel'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('common.confirm'),
          role: 'ok',
          handler: async () => {
            await lastValueFrom(this.commentService.reportComment(this.comment.id)).then(async () => {
              await this.sharedService.showToast(this.translate.instant('news.comments.success.report'));
              await this.popoverCtrl.dismiss({ refresh: true, comment: null });
            });
          },
        },
      ],
    });
    await alert.present();
  }

  async editComment() {
    this.popoverCtrl.dismiss({ refresh: true, comment: this.comment });
  }
}
